import axios from 'axios';
import store from '@/store';
import Vue from 'vue'
import { errorHandler } from '@/utils/errorHandler';

// import router from '../router';

// 设置全局axios默认值
axios.defaults.timeout = 50000; // 5000的超时验证
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';

// 创建一个axios实例
const instance = axios.create({
  baseURL: `${process.env.VUE_APP_URL}/api/competition`,
});
instance.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';

// request拦截器
instance.interceptors.request.use(
  (config) => {
    const userInfo = store.state.user.userInfo || {};
    const token = userInfo.token || userInfo.accessToken || '';
    if (token) {
      /* eslint no-param-reassign: "error" */
      config.headers.Authorization = token;
    }
    
    return config;
  },
  err => Promise.reject(err),
);

// respone拦截器
instance.interceptors.response.use(
  (response) => {
    const { data = {} } = response;
    
    const { status } = data;
    if (status === 401) {
      errorHandler('您的账号已在其他设备登录，如非本人操作，请及时修改密码后重新登录！').then(() => store.dispatch('LogOut'));
    }
    return data;
  },
  (error) => { // 默认除了2XX之外的都是错误的，就会走这里
    if (error.message === 'Network Error') {
      errorHandler('网络错误，请检查网络');
    }
    if (/status code 401/i.test(error.message)) {
      errorHandler('您的账号已在其他设备登录，如非本人操作，请及时修改密码后重新登录！').then(() => store.dispatch('LogOut'));
    } else if (error.response) {
      if (error.response.status === 401) {
        errorHandler('您的账号已在其他设备登录，如非本人操作，请及时修改密码后重新登录！').then(() => store.dispatch('LogOut'));
      }
    }
    Vue.prototype.$vmLoading.hide()
    return Promise.reject(error.response);
  },
);

export default instance;
